import { Box, Skeleton, Stack, StackProps } from '@mui/material';
import React from 'react';

export interface HeroSectionSkeletonProps {
  sx?: StackProps['sx'];
}

const HeroSectionSkeleton = ({ sx }: HeroSectionSkeletonProps) => {
  return (
    <Stack direction={{ xs: 'column-reverse', md: 'row' }} py="48px" sx={sx}>
      <Stack gap="8px" flex={1}>
        <Skeleton variant="text" width="70%" sx={{ fontSize: 20 }} />
        <Skeleton variant="text" width="60%" sx={{ fontSize: 12 }} />
        <Skeleton variant="text" width="40%" sx={{ fontSize: 14 }} />
      </Stack>

      <Box flex={1}>
        <Skeleton variant="rounded" height={250} sx={{ aspectRatio: '3/2' }} />
      </Box>
    </Stack>
  );
};

export default HeroSectionSkeleton;
